<script>
import { createEditDeltaComponent } from '@/components/edit-delta-factory';
import commonMixin from '@/plans/TRANSLATION_CAPTIONS/mixin';
import { planTypes } from '@/common/constants';

export default createEditDeltaComponent({
  name: 'TranslationCaptionsEditDelta',
  planType: planTypes.TRANSLATION_CAPTIONS,
  mixin: commonMixin,
});
</script>

<style lang="scss">
.opc-zwb {
  &__preview-payment {
    margin-top: 24px;
  }
}
</style>
